module.exports = "/images/vendor/svg-country-flags/svg/ru.svg?f6bf75dc753a7e2944a7871bcdd29e60";